import {AiEntityReference} from "../../generated-sources/api/ai/model/ai-entity-reference";
import {AiSuggestedAction} from "../../generated-sources/api/ai/model/ai-suggested-action";

export const aiChatFeatureKey = "aiChat";

export function generateUUID(): string {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
    }
    return Array.from(crypto.getRandomValues(new Uint8Array(16)),
        b => b.toString(16).padStart(2, "0")).join("");
}

export interface AiChatMessage {
  role: "user" | "assistant";
  content: string;
  entityReferences?: AiEntityReference[];
  suggestedActions?: AiSuggestedAction[];
  timestamp: number;
}

export interface AiChatState {
  conversationId: string;
  isOpen: boolean;
  messages: AiChatMessage[];
  streamingText: string;
  streamingEntityReferences: AiEntityReference[];
  streamingSuggestedActions: AiSuggestedAction[];
  isStreaming: boolean;
  toolCallStatus: { tool: string; status: string } | null;
  error: string | null;
}

export const initialAiChatState: AiChatState = {
  conversationId: generateUUID(),
  isOpen: false,
  messages: [],
  streamingText: "",
  streamingEntityReferences: [],
  streamingSuggestedActions: [],
  isStreaming: false,
  toolCallStatus: null,
  error: null,
};
